export default "__VITE_ASSET__YFi5TnNf__"